import { render, staticRenderFns } from "./CreateAutoReply.vue?vue&type=template&id=0c055499&scoped=true"
import script from "./CreateAutoReply.vue?vue&type=script&lang=js"
export * from "./CreateAutoReply.vue?vue&type=script&lang=js"
import style0 from "./CreateAutoReply.vue?vue&type=style&index=0&id=0c055499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c055499",
  null
  
)

export default component.exports